<template>
  <a @click="switchLocale">{{options[this.toggleLanguage]}}</a>
</template>

<script>
    export default {
      name: "LocaleSwitcher",
      data: function() {
        return {
          locale: this.$i18n.locale,
          options: {
            'en': 'English',
            'es': 'Español',
          }
        }
      },
      computed: {
        toggleLanguage () {
          return this.$i18n.locale === 'en' ? 'es' : 'en'
        }
      },
      mounted() {
      },
      methods: {
        switchLocale () {
          if (this.$i18n.locale === 'en') {
            this.$i18n.locale = 'es'
          }
          else this.$i18n.locale = 'en'
        }
      }
    }
</script>

<style scoped>
  a {
    line-height: 24px;
    width: 100px;
    background-color: #244148;
    color: white;
    text-align: center;
    display: block;
    border-radius: 30px;
    padding: 2px;
  }

  a:hover {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/LocaleSwitcher.vue